import { Application, Packlink } from '@packlink/packlink-sdk';

import { getAuthorization } from '@utils';

const packlink = new Packlink(
    config.api,
    Application.SINGLE_FLOW,
    undefined,
    getAuthorization(),
    undefined,
    __PACKLINK_APP_VERSION__,
);

export default packlink;
